<template>

<app-page title="Patients" back="Dashboard" :is-loading="is.loading">

    <app-panel title="Patients" :is-loading="is.loading" :is-empty="is.empty">

        <app-table>
            <thead>
                <tr>
                    <th width="100">Pseudo ID</th>
                    <th>Name</th>

                    <th align="center" class="border">D1</th>
                    <th align="center" >D2</th>
                    <th align="center" >D3</th>
                    <th align="center" >D4</th>
                    <th align="center" >D5</th>
                    <th align="center" >D6</th>

                    <th width="120" align="center" class="border">DOB</th>
                    <th align="center" width="120">Access Code</th>
                    <th width="60"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection" :key="item.id">
                    <td>{{ item.reference }}</td>
                    <td>{{ item.name }}<small>{{ item.email || 'No e-mail provided.' }}</small></td>

                    <td align="center" :class="{'border': domain === 1}" v-for="domain in domains" :key="domain">
                    
                        <div class="domain is-empty" v-if="!item.domains[domain].completed">-</div>
                        <div class="domain is-completed" v-tooltip="'Ready to review'" v-if="item.domains[domain].completed && !item.domains[domain].reviewed">!</div>
                        <div class="domain is-reviewed" v-tooltip="'Reviewed'" v-if="item.domains[domain].reviewed">&check;</div>
                    
                    </td>

                    <td align="center" class="border">{{ item.dob }}</td>
                    <td align="center">{{ item.code }}</td>
                    <td><app-button text="View" route="Patient" :id="item.id" /></td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

    <input ref="upload" type="file" accept=".csv" style="display: none;" v-on:change="onFileSelected" />

    <app-actions>

        <app-button text="Add Patient" route="Patient" id="create" />
        <app-button text="Import Patients" :is-loading="is.importing" theme="grey" v-on:click.native="onImportClick" />

    </app-actions>

</app-page>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: 'patients',
            domains: 6,
            is: {
                importing: false
            }
        }
    
    },

    methods: {
    
        onImportClick: function() {

            this.$refs.upload.click()
        
        },

        onFileSelected: function(e) {

            this.is.importing = true

			var file = e.target.files[0]

			var reader = new FileReader()

			reader.onload = function() {

                this.$api.post('patients', {
                    data: reader.result
                }).then(function() {

                    this.$notify({
                        message: 'Import completed successfully.'
                    })

                    this.load()

                    this.is.importing = false
                
                }.bind(this), function() {

                    this.$notify({
                        type: 'error',
                        message: 'Import failed, please check format is Firstname, Lastname, DOB, Email.'
                    })

                    this.is.importing = false
                
                }.bind(this))

			}.bind(this)

			reader.readAsText(file)
			
		}
    
    }

}

</script>

<style scoped>

.domain {
    width: 24px;
    height: 24px;
    display: block;
    border-radius: 50%;
    margin: 0px auto;
    text-align: center;
    line-height: 24px;
}

.domain.is-empty {
    color: #ccc;
}

.domain.is-completed {
    color: #fff;
    background-color: #f39647;
}

.domain.is-reviewed {
    color: #fff;
    background-color: #40b067;
}

</style>
